export interface FetchPatientsQueryParam {
    id: string | number;
    phone_number: string;
    pathologies: string;
    fullname: string;
    email: string;
    id_card: string;
    id_number: string;
    order_by: string;
    order_direction: 'asc' | 'desc';
    per_page: number | string;
    page: string | number;
}